export const isEmail = (email: string): boolean => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email.trim());
};

export const isPhone = (str: string): boolean => {
  return str.length >= 7;
};

export const isName = (str: string): boolean => {
  return str.length >= 5;
};
